(function () {
    'use strict';

    angular
        .module('app')
        .controller('ResetPasswordController', ResetPasswordController);

    function ResetPasswordController($scope, $state, $stateParams, $rootScope, PasswordService) {

        var vm = this;
        vm.userData = {
            userId: "",
            code: "",
            Password: "",
            ConfirmPassword: ""
        };

        vm.resetPassword = resetPassword;
        vm.userData.userId = $rootScope.userId;
        vm.userData.code = $rootScope.code;
        vm.isWebApiCallFailed = false;
       
        
        function resetPassword(isFormInvalid) {
            vm.isWebApiCallFailed = false;
            if (!isFormInvalid) {
                PasswordService.resetPassword(vm.userData).then(function (data) {
                    $rootScope.messageData = { code: "ResetPasswordSuccess", title: "Reset Password Success" };
                    $state.go('displayMessage');
                }, function (result) {
                    $rootScope.messageData = { code: "ResetPasswordFail", title: "Reset Password Failed" };
                    $state.go('displayMessage');
                });
            }
        }

        $scope.$watch('vm.userData', function (newObject, oldObject) {
            if (newObject.Password != oldObject.Password) {
                vm.passwordStrength = PasswordService.getStrength(newObject.Password);
                vm.passwordProgressStyle = { width: vm.passwordStrength + '%' };

                if (vm.isPasswordWeak()) {
                    $scope.resetpasswordform.password.$setValidity('strength', false);
                } else {
                    $scope.resetpasswordform.password.$setValidity('strength', true);
                }
                //console.log(vm.passwordProgressStyle);
            }
        }, true);

        vm.isPasswordWeak = function () {

            return vm.passwordStrength < 40;
        }

        vm.isPasswordOk = function () {

            return vm.passwordStrength >= 40 && vm.passwordStrength <= 70;
        }

        vm.isPasswordStrong = function () {

            return vm.passwordStrength > 70;
        }

    }
})();